export default __webpack_public_path__ + "static/1881-5fe53f6f60da5c19d4e816bed2288ac9.gif";